const _i18n_warning = {
  file_size : {
    EN: `Maximum file size exceeded.`,
    KO: `Maximum file size exceeded.`,
    JP: `最大ファイルサイズを超えました`
  }
}

const _i18n_error = {
  file_selection : {
    EN: `File selection required.`,
    KO: `File selection required.`,
    JP: `ファイルの選択が必要です`
  }
}

const i18n_toastr = {
  _i18n_warning,
  _i18n_error
}

export default i18n_toastr